<nz-modal
    [nzVisible]="visible"
    [nzTitle]="isEditMode ? 'Edit Moderator' : 'Add Moderator'"
    (nzOnCancel)="onCancel()"
    (nzOnOk)="onOk()"
    [nzOkLoading]="saving"
    nzOkText="Save"
    nzWidth="480px">
    <ng-container *nzModalContent>
        <form nz-form [formGroup]="form" nzLayout="vertical">
            <ng-container *ngIf="!isEditMode && allowExistingSelect">
                <nz-form-item>
                    <nz-form-label>Mode</nz-form-label>
                    <nz-form-control>
                        <nz-radio-group formControlName="mode">
                            <label nz-radio nzValue="existing">Use Existing Moderator</label>
                            <label nz-radio nzValue="new">Create New Moderator</label>
                        </nz-radio-group>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="isExistingMode">
                    <nz-form-label nzRequired>Select Moderator</nz-form-label>
                    <nz-form-control nzErrorTip="Please select a moderator">
                        <nz-select
                            formControlName="existing_moderator_id"
                            nzShowSearch
                            nzAllowClear
                            nzPlaceHolder="Search existing moderators">
                            <nz-option
                                *ngFor="let item of allModerators"
                                [nzValue]="item.id"
                                [nzLabel]="item?.name + (item?.company ? ' - ' + item.company : '')"
                                [nzDisabled]="isAlreadyLinked(item.id)">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </ng-container>

            <ng-container *ngIf="!isExistingMode">
            <nz-form-item>
                <nz-form-label nzRequired>Name</nz-form-label>
                <nz-form-control nzErrorTip="Name is required">
                    <input nz-input formControlName="name" placeholder="Full name" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label>Company</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="company" placeholder="Company name" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label>Job Title</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="job_title" placeholder="Job title" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label>Email</nz-form-label>
                <nz-form-control nzErrorTip="Please enter a valid email">
                    <input nz-input formControlName="email" placeholder="email@example.com" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label>Phone Number</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="phone_number" placeholder="Phone number" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label>LinkedIn URL</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="linkedin_url" placeholder="https://linkedin.com/in/..." />
                </nz-form-control>
            </nz-form-item>
            </ng-container>
        </form>
    </ng-container>
</nz-modal>
